import { useDispatch } from 'react-redux';

import { createBudget } from 'loot-core/client/actions';

import { AsyncStorageKey, useStorage } from './useStorage';
import { useLocalPref } from './useLocalPref';

export function useDemoSite() {
  const dispatch = useDispatch();
  const [budgetId] = useLocalPref('id');
  const { setItem: setDemoBudgetStartDate } = useStorage(AsyncStorageKey.DEMO_BUDGET_START_DATE);

  const createDemoBudget = async () => {
    dispatch(createBudget({ demoMode: true }));
    await setDemoBudgetStartDate(new Date().toISOString());
  };

  const isDemoSite = window.location.hostname === 'demo.goodsteward.io';
  const isDemoBudgetFile = budgetId === '_demo-budget';

  return { createDemoBudget, isDemoSite, isDemoBudgetFile };
}
